export const safeParseInt = (value: unknown, radix?: number): number | null => {
  if (value === null || value === undefined) {
    return null;
  }
  const parsed = Number.parseInt(value.toString(), radix);
  return Number.isNaN(parsed) ? null : parsed;
};

export const isValidNumber = (value: unknown): value is number => {
  if (typeof value === "number") {
    return !Number.isNaN(value);
  }
  return safeParseInt(value) !== null;
};

export const toLocaleNumberText = (
  value: number | undefined | null,
): string | null => {
  if (value === null || value === undefined) {
    return null;
  }
  return value.toLocaleString();
};
